export const API_BASE = (
  process.env.REACT_APP_BACKEND_URL || "https://api.survipos.com"
).replace(/\/+$/, "");
